var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atras",on:{"click":_vm.atras}},[_c('img',{attrs:{"src":require("@/assets/img/1x/Arrow-Left.png"),"alt":"Flecha a la izquierda"}}),_c('p',{staticClass:"anterior"},[_vm._v("Anterior")])])
}
var staticRenderFns = []

export { render, staticRenderFns }